import React from 'react'
import { GrEdit } from "react-icons/gr";

const SecurityQuestion = ({ setQuesDialog, questionValue, ansValue }) => {
    return (
        <div className="gray-bg-border mt-3">
            <div className="d-flex justify-content-between gap-2">
                <h6 className="dark-gray f-bold">
                    Security Question:{" "}
                </h6>
                <h6 className="darkgray">
                    <span
                        onClick={() => {
                            setQuesDialog(true);
                        }}
                    >
                        <GrEdit />
                    </span>
                </h6>
            </div>

            <h6 className="darkgray  normal-w"> {questionValue}</h6>
            <h6 className="dark-gray f-bold">{ansValue} </h6>
        </div>
    )
}

export default SecurityQuestion